import { useState } from 'react';
import { isArray, isString } from 'lodash';

import { Button, Input } from 'antd';
import { useParams } from 'react-router-dom';

import { Form, StyledModal, CustomNotification } from 'common/components';

import { validateMultipleEmails } from 'utils';

import { useValidateRecaptureProduct, useRecaptureProduct } from './queries';
import { useCheckIsProductOverlay } from 'hooks';
import './ProductRecapture.less';

const ProductRecapture = (props) => {
  const { id } = useParams();
  const [formInstance] = Form.useForm();

  const { disabled } = props;

  const validateRecaptureProduct = useValidateRecaptureProduct();
  const recaptureProduct = useRecaptureProduct();

  const [open, setOpen] = useState(false);

  const isProductOverlay = useCheckIsProductOverlay({
    productId: id,
  });

  const handleValidateAndOpenModal = () => {
    validateRecaptureProduct.mutate(
      { productId: id },
      {
        onSuccess: (res) => {
          if (res?.isSuccess) {
            setOpen(true);
            const data = res?.data?.formData;
            formInstance.setFieldsValue({
              ...data,
              emails: isArray(data?.emails) ? data?.emails?.join(';') : '',
            });
          } else {
            CustomNotification.error(res?.message || 'Something went wrong!');
          }
        },
        onError: (error) => {
          CustomNotification.error('Something went wrong!');
        },
      }
    );
  };

  const onCancel = () => {
    setOpen(false);
  };

  const onOk = async () => {
    await formInstance.validateFields().then(async (value) => {
      let params = Object.assign(
        {
          formData: {
            ...value,
            emails: isString(value?.emails) ? value?.emails?.split(',') : [],
          },
        },
        {
          productId: id,
        }
      );

      recaptureProduct.mutate(params, {
        onSuccess: (result) => {
          if (result?.isSuccess) {
            CustomNotification.success(
              'Your recapture request has been submitted successfully.'
            );
            setOpen(false);
          } else {
            CustomNotification.error(
              result?.message || 'Something went wrong!'
            );
          }
        },
        onError: (error) => {
          CustomNotification.error('Something went wrong!');
        },
      });
    });
  };

  return !isProductOverlay ? (
    <div>
      <Button
        className='product-recapture-draggable-button'
        type='primary'
        size='large'
        loading={validateRecaptureProduct.isLoading}
        onClick={handleValidateAndOpenModal}
        disabled={disabled}
      >
        Recapture Item
      </Button>
      {open && (
        <StyledModal
          visible={open}
          title={'Recapture Item'}
          maskClosable={false}
          width={'520px'}
          okText='Send'
          okButtonProps={{ loading: recaptureProduct.isLoading }}
          onCancel={onCancel}
          onOk={onOk}
        >
          <Form form={formInstance} layout={'vertical'}>
            <Form.Item
              label='Name'
              name='name'
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label='Emails - for multiple emails, separate each with a ";"'
              name='emails'
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
                {
                  validator: (_, value) => {
                    const validateEmail = validateMultipleEmails(value, ';');
                    if (validateEmail || !value) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject('Invalid email format');
                    }
                  },
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label='Phone'
              name='phone'
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label='Company'
              name='companyName'
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label='Message Title'
              name='title'
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label='Reason for Recapture - ex) Packaging Change'
              name='reason'
              rules={[
                {
                  required: true,
                  message: 'This field is required',
                },
              ]}
            >
              <Input.TextArea autoSize={{ minRows: 5, maxRows: 5 }} />
            </Form.Item>
          </Form>
        </StyledModal>
      )}
    </div>
  ) : null;
};

export default ProductRecapture;
